module.exports = __webpack_public_path__ + "img/商务微信@2x.da2da673.png";